export default __webpack_public_path__ + "static/media/background-01@2x.62e590fb.webp";